import { render, staticRenderFns } from "./pageEquipment.vue?vue&type=template&id=5b80a298&scoped=true&"
import script from "./pageEquipment.vue?vue&type=script&lang=js&"
export * from "./pageEquipment.vue?vue&type=script&lang=js&"
import style0 from "./pageEquipment.vue?vue&type=style&index=0&id=5b80a298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b80a298",
  null
  
)

export default component.exports